import { useEffect, useState } from 'react'
import { getModeHistory } from '@/services/realtime.service'
import { Card, CardContent, Chip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const columns = [
    {
        field: 'DateTime',
        headerName: 'Date',
        width: 200,
        renderCell: (params) => {
            return moment(params?.value).format('DD/MM/YYYY HH:mm')
        },
    },
    {
        field: 'Value',
        headerName: 'Mode',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
            let mode =
                params?.value == 2
                    ? 'HEAT'
                    : params?.value == 1
                      ? 'COOL'
                      : params?.value == 3
                        ? 'DRY'
                        : params?.value == 4
                          ? 'FAN'
                          : 'AUTO'
            let backgroundColor =
                mode == 'HEAT'
                    ? '#ff8a80'
                    : mode == 'COOL'
                      ? '#2196f3'
                      : mode == 'DRY'
                        ? '#ff8a80'
                        : mode == 'FAN'
                          ? '#A1E8A1'
                          : '#cfd8dc'

            return <Chip style={{ backgroundColor: backgroundColor, color: 'white' }} label={mode} />
        },
    },
]

export const ModeHistoryComponent = ({ hash, objectId }) => {
    let [modes, setModes] = useState([])
    const { t } = useTranslation('site', { keyPrefix: 'dashboard.hvac.objectHistory.modeHistory' })

    useEffect(() => {
        if (hash && objectId) {
            init()
        }
    }, [hash, objectId])

    const init = async () => {
        setModes([])
        let res = await getModeHistory(hash, objectId)
        if (res?.message?.modeHistory?.length > 0) {
            let _modes = removeConsecutiveDuplicates(res?.message?.modeHistory)
            // sort based on the DateTime column in descending order
            _modes.sort((a, b) => new Date(b.DateTime) - new Date(a.DateTime))

            setModes(_modes)
        }
    }

    function removeConsecutiveDuplicates(arr) {
        let lastUnique = null

        return arr.filter((obj) => {
            // Check if the current object is different from the last unique object based on `Value` and `SensorId`
            if (!lastUnique || lastUnique.Value !== obj.Value || lastUnique.SensorId !== obj.SensorId) {
                // Update last unique object and include this object in the final array
                lastUnique = obj
                return true
            }
            // If the current object is a duplicate, skip it
            return false
        })
    }

    if (!modes) return null
    else {
        return (
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {t('title')}
                    </Typography>
                    <DataGrid
                        rows={modes.map((el) => {
                            return { ...el, id: el?.DataMeasurementId }
                        })}
                        columns={columns}
                        pageSize={5}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 5 },
                            },
                        }}
                        pageSizeOptions={[5, 10]}
                        rowsPerPageOptions={[5, 10]}
                        // components={{ Toolbar: CustomToolbar }}
                        localeText={{
                            MuiTablePagination: {
                                labelRowsPerPage: t('tableOptions.rowsPerPage'),
                            },
                        }}
                        sx={{
                            border: 0,
                        }}
                        autoHeight={true}
                        // onCellClick={onCellClick}
                    />
                </CardContent>
            </Card>
        )
    }
}
